import { EmergencyState } from "./types";

export const defaultState = (): EmergencyState => {
  return {
    emergencyData: null
  };
};

export const state = defaultState();
